import styled from 'styled-components';

export const AmenitiesContent = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.wide ? 'repeat(4, 1fr)' : 'repeat(6, 1fr)')};
  gap: 0.5rem;
  width: 100%;
  align-items: center;
  justify-items: center;

  @media (max-width: 768px) {
    grid-template-columns: ${(props) => (props.wide ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)')};
    gap: 0.5rem;
  }
`;

export const AmenitiesContainer = styled.div`
  margin-top: 24px;
`;

export const AmenityWrapper = styled.div`
  width: ${(props) => (props.wide ? '140px' : '105px')};
  height: 110px;
  border: 1px solid #283618;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: ${(props) => (props.isSelected ? 1 : 0.3)};
  @media (max-width: 768px) {
    width: ${(props) => (props.wide ? '120px' : '90px')};
    height: 110px;
    padding: 8px;
    gap: 6px;
  }
`;

export const AmenityName = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #283618;
  z-index: 1;
  text-align: center;
`;
